export default "https://cdn-static.gokick.com/assets/5d59d840aa8978759fe32f9d0593dfb9088da5d0/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";